import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState, useMemo, useEffect } from 'react';
import '../../../../constants/icons/generic/index.mjs';
import { handleKeyboardActivation, createLinkHandler } from '../../../../contexts/MenuContext/utils.mjs';
import '../../../../contexts/MicrositeMenuContext/index.mjs';
import { MenuCategoryId } from '../../../../contexts/MicrositeMenuContext/mapping.mjs';
import { useMicrositeMenuTranslations } from '../../../../contexts/MicrositeMenuContext/translations.mjs';
import { imageSrc } from '../../../../utils/asset.mjs';
import './assets/sitemap.png.mjs';
import { GlassCover, Wrap, MenuWrap, MenuInnerWrap, Container, PrimaryList, ListItem, Link, ActiveCursor, RightWrap, ColumnList, GridCard, GridCardImage, ItemContainer, GridCardLabel, GridCardButton, ArrowRightIcon, Column, ColumnHeading, ColumnItem, ScrollWrapper, GridCardImagePlaceholder } from './DropdownMenu.styles.mjs';
import { useMicrositeMenu } from '../../../../contexts/MicrositeMenuContext/context.mjs';
import SiteMapImg__default from "../../../../assets/sitemap.png";
import carouselArrowRight__default from "../../../../assets/carouselArrowRight.svg";
"use strict";
const CATEGORY_WIDTH_MAP = {
  [MenuCategoryId.CloudGateways]: 146,
  [MenuCategoryId.Switching]: 114,
  [MenuCategoryId.WiFi]: 90,
  [MenuCategoryId.PhysicalSecurity]: 154,
  [MenuCategoryId.Integrations]: 110
};
const DropdownMenu = ({
  show,
  // stickyHeader,
  items,
  onMenuItemClick,
  onMouseLeave,
  onClose,
  onSiteMapClick
}) => {
  const motif = "light";
  const {
    language
  } = useMicrositeMenu();
  const [activeItemId, setActiveItemId] = useState();
  const activeItem = useMemo(() => items?.find(item => item.id === activeItemId), [activeItemId, items]);
  useEffect(() => {
    setActiveItemId(items?.[0]?.id);
  }, [items]);
  const {
    formatMessage
  } = useMicrositeMenuTranslations(language);
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(GlassCover, {
      $show: show,
      onClick: onClose
    }), /* @__PURE__ */jsx(Wrap, {
      onMouseLeave,
      children: /* @__PURE__ */jsx(MenuWrap, {
        $motif: motif,
        $slideInView: show,
        children: /* @__PURE__ */jsx(MenuInnerWrap, {
          $shouldShow: show,
          children: /* @__PURE__ */jsxs(Container, {
            size: "desktop",
            noVerticalMargin: true,
            children: [/* @__PURE__ */jsx(PrimaryList, {
              children: items?.map((item, index) => /* @__PURE__ */jsxs(ListItem, {
                role: "button",
                tabIndex: 0,
                onKeyDown: handleKeyboardActivation(e => {
                  e.preventDefault();
                  setActiveItemId(item.id);
                }),
                children: [/* @__PURE__ */jsx(Link, {
                  $motif: motif,
                  $active: activeItemId === item.id,
                  href: item.items?.length ? void 0 : item.url,
                  $slideInView: show,
                  $fadeInDelay: (index + 1) * 80,
                  onMouseOver: e => {
                    if (item.items?.length) {
                      e.preventDefault();
                      setActiveItemId(item.id);
                    }
                  },
                  onClick: e => {
                    if (item.items?.length) {
                      e.preventDefault();
                    }
                  },
                  children: formatMessage(item.label)
                }), /* @__PURE__ */jsx(ActiveCursor, {
                  $isActive: activeItemId === item.id
                })]
              }, item.id))
            }), /* @__PURE__ */jsx(RightWrap, {
              children: activeItem?.variant === "column-list" ? /* @__PURE__ */jsxs(ColumnList, {
                children: [/* @__PURE__ */jsxs(GridCard, {
                  as: "button",
                  tabIndex: 0,
                  $slideInView: show,
                  $fadeInDelay: 0,
                  onKeyDown: handleKeyboardActivation(e => {
                    e.preventDefault();
                    onSiteMapClick?.();
                  }),
                  onClick: onSiteMapClick,
                  children: [/* @__PURE__ */jsx(GridCardImage, {
                    src: imageSrc(SiteMapImg__default),
                    height: 146,
                    width: 160
                  }), /* @__PURE__ */jsxs(ItemContainer, {
                    children: [/* @__PURE__ */jsx(GridCardLabel, {
                      $isRow: true,
                      children: formatMessage("menu.label.viewSiteMapTopology")
                    }), /* @__PURE__ */jsxs(GridCardButton, {
                      $isRow: true,
                      as: "div",
                      children: [/* @__PURE__ */jsx("span", {
                        children: formatMessage("commons.expand")
                      }), /* @__PURE__ */jsx(ArrowRightIcon, {
                        src: carouselArrowRight__default,
                        height: 10,
                        width: 6
                      })]
                    })]
                  })]
                }), activeItem?.items?.map(item => /* @__PURE__ */jsxs(Column, {
                  $width: CATEGORY_WIDTH_MAP?.[item.id],
                  children: [/* @__PURE__ */jsx(ColumnHeading, {
                    children: formatMessage(item.label)
                  }), item.items?.map(subItem => /* @__PURE__ */jsx(ColumnItem, {
                    role: "button",
                    tabIndex: 0,
                    href: subItem.url,
                    onKeyDown: handleKeyboardActivation(e => {
                      e.preventDefault();
                      onMenuItemClick?.(e, subItem.url);
                      onClose?.();
                    }),
                    onClick: e => {
                      onMenuItemClick?.(e, subItem.url);
                      onClose?.();
                    },
                    children: formatMessage(subItem.label)
                  }, subItem.id))]
                }, item.id))]
              }) : /* @__PURE__ */jsx(ScrollWrapper, {
                align: "left",
                direction: "horizontal",
                scrollStepType: "visibleItemsWidth",
                gap: 16,
                fillType: "gradient",
                fillColor: "#fff",
                arrowColor: "#828893",
                gradientSize: 160,
                enableWheelScroll: true,
                items: activeItem?.items ? activeItem.items.map((item, index) => ({
                  id: `menu-item-${item.id}`,
                  render: function Render() {
                    return /* @__PURE__ */jsxs(GridCard, {
                      tabIndex: 0,
                      onKeyDown: handleKeyboardActivation(createLinkHandler({
                        href: item.url,
                        isExternal: item.isExternalUrl,
                        onClick: e => onMenuItemClick?.(e, item.url),
                        onClose
                      })),
                      $slideInView: show,
                      href: item.url,
                      target: item.isExternalUrl ? "_blank" : void 0,
                      rel: item.isExternalUrl ? "noopener noreferrer" : void 0,
                      $fadeInDelay: ((items?.length ?? 0) + index) * 80,
                      onClick: e => {
                        if (!item.isExternalUrl) {
                          onMenuItemClick?.(e, item.url);
                        }
                        onClose?.();
                      },
                      children: [item.image ? /* @__PURE__ */jsx(GridCardImage, {
                        src: imageSrc(item.image.src),
                        height: item.image.height,
                        width: item.image.width,
                        alt: formatMessage(item.label)
                      }) : /* @__PURE__ */jsx(GridCardImagePlaceholder, {}), /* @__PURE__ */jsxs(ItemContainer, {
                        children: [/* @__PURE__ */jsx(GridCardLabel, {
                          $isRow: true,
                          children: formatMessage(item.label)
                        }), !!item.actionLabel && /* @__PURE__ */jsxs(GridCardButton, {
                          $isRow: true,
                          onClick: e => onMenuItemClick?.(e, item.url),
                          role: "button",
                          children: [/* @__PURE__ */jsx("span", {
                            children: formatMessage(item.actionLabel)
                          }), /* @__PURE__ */jsx(ArrowRightIcon, {
                            src: carouselArrowRight__default,
                            height: 10,
                            width: 6
                          })]
                        })]
                      })]
                    }, item.id);
                  }
                })) : []
              })
            })]
          })
        })
      })
    })]
  });
};
export { DropdownMenu };
//# sourceMappingURL=DropdownMenu.mjs.map
